// extracted by mini-css-extract-plugin
export default {"map_container":"places_map_container__w-8g+","image_container":"places_image_container__kh2P7"};